import React from "react";

export default function NotFoundPage() {
  return (
    <div className="container d-flex flex-column align-items-center justify-content-center min-vh-100 bg-light text-center py-5">
      <div className="mb-5">
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h2 className="h4 fw-semibold text-dark mb-3">Oops! Page Not Found</h2>
        <p className="text-muted lead mb-4">
          The page you're looking for doesn't exist or has been moved. But don't worry — there's still a world of opportunities waiting for you.
        </p>

        <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
          <a href="/" className="btn btn-primary px-4 py-2">Go to Homepage</a>
          <a href="/jobs" className="btn btn-outline-primary px-4 py-2">Browse Jobs</a>
          <a href="/categories" className="btn btn-outline-primary px-4 py-2">Top Categories</a>
        </div>

        <p className="text-primary fw-semibold mb-1 fs-5">
          🔎 Open Positions: <span className="fs-4 fw-bold">1,205</span>
        </p>
        <p className="text-muted mb-5">Your next opportunity might be just a click away.</p>
      </div>

      <div className="bg-white border rounded shadow-sm p-4 w-100" style={{ maxWidth: "500px" }}>
        <h3 className="h5 fw-bold text-dark mb-2">
          📬 Join Our Talent Network
        </h3>
        <p className="text-muted small mb-3">
          Be the first to receive jobs & tasks by SMS or Email.
        </p>
        <form className="d-flex gap-2">
          <input
            type="email"
            placeholder="Enter your email"
            className="form-control"
          />
          <button
            type="submit"
            className="btn btn-pink text-white"
            style={{ backgroundColor: "#e83e8c" }}
          >
            Subscribe
          </button>
        </form>
      </div>

      <footer className="mt-5 text-muted small text-center">
        <p className="mb-1 fw-medium">JOBFLOW CVP</p>
        <p className="mb-1">Connecting Local Talent with Real Opportunities</p>
        <div className="d-flex justify-content-center gap-3 mb-2">
          <a href="#" className="text-decoration-none text-primary">Facebook</a>
          <a href="#" className="text-decoration-none text-primary">Twitter</a>
          <a href="#" className="text-decoration-none text-primary">LinkedIn</a>
        </div>
        <p className="mt-3">HTTP 404 - Page Not Found</p>
      </footer>
    </div>
  );
}
